import axios from 'axios'
import ICompanyForm from '@/types/ICompanyForm';
import ICompanySettingsForm from '@/types/ICompanySettingsForm';

export default class CompanyRepository {
  static fetchCompanyInfo(): Promise<any> {
    return axios.get('company/info')
  }

  static updateCompanyAddress(data: ICompanyForm): Promise<any> {
    return axios.put(`company/address/${data.addressId}`, data)
  }

  static updateCompanySettings(data: ICompanySettingsForm): Promise<any> {
    return axios.post('company/params', data)
  }
}
